var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8945 8.8945C19.263 9.26311 19.2624 9.86075 18.8938 10.2293L15.1125 14.0107L18.7833 17.6815C19.1519 18.0502 19.1519 18.6484 18.7833 19.017C18.4147 19.3855 17.8171 19.3849 17.4485 19.0164L13.7776 15.3455L10.3291 18.794C9.96055 19.1626 9.36292 19.1632 8.99432 18.7947C8.62571 18.4261 8.62571 17.8278 8.99432 17.4592L12.4428 14.0107L8.88383 10.4517C8.51528 10.0831 8.51467 9.48548 8.88314 9.11686C9.25174 8.74826 9.85004 8.74826 10.2186 9.11686L13.7776 12.6759L17.559 8.8945C17.9276 8.52591 18.5259 8.5259 18.8945 8.8945Z",
    fill: "#B80A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.b87c4ffa1f6cf198d44357b8ad9f9971.svg";
export { ForwardRef as ReactComponent };